export const companyAuctionPermissionFragment = `
  fragment companyAuctionPermissions on CompanyAuctionPermission {
    id
    name
  }
`;
